import { type FC } from 'react';
import { AdUnit } from './AdUnit';

import { type OnSlotRenderEnded, type AdSizes } from '../types';

import styles from '../styles/ads.scss';

type Props = {
    adId: string;
    elementId: string;
    width?: number;
    height?: number;
    lazyLoad?: boolean;
    sizes?: AdSizes;
    heightHold?: number;
    widthHold?: number;
};

const onSlotRenderEnded: OnSlotRenderEnded = (event, ref, elementId) => {
    const iframe = ref.querySelector('iframe');
    if (event.slot.getSlotElementId() === elementId && iframe) {
        const innerDoc = iframe.contentDocument || iframe?.contentWindow?.document;
        const body = innerDoc?.querySelector('body');
        const adImg = innerDoc?.querySelector('img');
        const imgLinkElement = adImg?.parentElement;
        const googleImgDiv = innerDoc?.querySelector('#google_image_div');
        googleImgDiv?.setAttribute('style', 'display: flex;');
        body?.setAttribute('style', 'display: flex; align-items: center; height: 100% !important;');
        innerDoc?.querySelector('html')?.setAttribute('style', 'height: 100%;');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        adImg?.setAttribute('width', '100%');
        adImg?.setAttribute('height', '100%');
        adImg?.setAttribute('style', 'height: 100%; width: 100%; position: static;');
        imgLinkElement?.setAttribute('style', 'display: flex;');
    }
};

const ProductTileAd: FC<Props> = ({
    adId,
    elementId,
    width = 331,
    height = 419,
    lazyLoad = false,
    sizes,
    heightHold,
    widthHold,
}) => {
    return (
        <div className={styles.tileContainer}>
            <div className={styles.tileInner} data-tn="product-tile-ad">
                <AdUnit
                    adId={adId}
                    elementId={elementId}
                    width={width}
                    height={height}
                    sizes={sizes}
                    heightHold={heightHold}
                    widthHold={widthHold}
                    className={styles.tilePlacement}
                    lazyLoad={lazyLoad}
                    onSlotRenderEnded={(event, ref) => onSlotRenderEnded(event, ref, elementId)}
                />
            </div>
        </div>
    );
};

export { ProductTileAd };
